import userService from '@/api/user'
import { USER_SETTINGS } from '../types'
import utils from '@/utils/utils.js'
import routerLogin from 'login/Router'

export default {
  namespaced: true,
  state: {
    userSettings: {
      pin: null,
      favoriteLocationId: null,
      favoriteSiteId: null,
      startWorkingTime: null,
      finishWorkingTime: null,
      costCenter: null,
      vehicles: []
    },
    costCenters: [],
  },
  getters: {
    vehicles (state) {
      return state.settings.vehicles
    }
  },
  mutations: {
    [USER_SETTINGS.SET_SETTINGS] (state, settings) {
      state.settings = settings
    },
    [USER_SETTINGS.SET_COST_CENTERS] (state, costCenter) {
      state.costCenters = costCenter
    },
    [USER_SETTINGS.PUSH_COST_CENTER] (state, code) {
      state.costCenters.push(code)
    },
    [USER_SETTINGS.REMOVE_COST_CENTER] (state, index) {
      state.costCenters.splice(index, 1)
    },
    [USER_SETTINGS.CLEAR_COST_CENTER] (state) {
      state.costCenters = []
    },
    [USER_SETTINGS.SET_VEHICLES] (state, vehicles) {
      state.settings.vehicles = vehicles
    }
  },
  actions: {
    getSettings: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        userService.getUserSettings().then((response) => {
          commit(USER_SETTINGS.SET_SETTINGS, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    saveSettings: function ({dispatch, rootGetters}, settings) {
      return new Promise((resolve, reject) => {
        userService.saveUserSettings(settings).then(() => {
          dispatch('Global/getInitialSettings', null, { root: true })
          routerLogin.push(utils.getLoadingPageRoute(rootGetters['Auth/isGlobalAdminHostname'], rootGetters['Global/hasBookingFeatures'], rootGetters['Global/hasMonitoring'], rootGetters['Global/hasComfort']))
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    setVehicles ({commit}, vehicles) {
      commit(USER_SETTINGS.SET_VEHICLES, vehicles)
    },
    pushCostCenter ({ commit }, item) {
      commit(USER_SETTINGS.PUSH_COST_CENTER, item)
    },
    clearCostCenter ({ commit }) {
      commit(USER_SETTINGS.CLEAR_COST_CENTER)
    },
    removeCostCenter ({ commit }, index) {
      commit(USER_SETTINGS.REMOVE_COST_CENTER, index)
    },
  }
}
